import { render, staticRenderFns } from "./LdSkeleton.vue?vue&type=template&id=08319145&scoped=true"
import script from "./LdSkeleton.vue?vue&type=script&lang=js"
export * from "./LdSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LdSkeleton.vue?vue&type=style&index=0&id=08319145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08319145",
  null
  
)

export default component.exports